import React, {Component} from "react";
import {Form, FormGroup, Input} from "reactstrap";


export default class VerificationCodeForm extends Component {

    render() {
        return (
            <Form id="verificationForm" data-testid="verificationForm">
                <FormGroup>
                    <Input
                        className={"generic-input gap-top-4"}
                        data-testid="verificationForm.input.verificationCode"
                        type="text"
                        name="verificationCode"
                        value={this.props.verificationCode}
                        onChange={this.props.handleChangeWithoutValidation}
                        id="verificationCode"
                        placeholder="Enter your verification code"
                    />
                </FormGroup>
                <div><p className={'error'} data-testid="verificationForm.error" >{this.props.error}</p></div>
                <div className={"auth-form-buttons gap-top-4"}>
                    <button className={'try-pi-btn auth-form-button-left'} data-testid="verificationForm.button.verify" onClick={this.props.verify}>VERIFY</button>
                    <button className={'try-pi-btn auth-form-button-right'} data-testid="verificationForm.button.resendCode" onClick={this.props.resendCode}>RESEND CODE</button>
                </div>
            </Form>
        );
    }
}